import { toast } from 'react-toastify'

export default {
  ValidateForm(form,message){
     if(!form.name){
      toast.warning("Name is empty!")
      return false
      
    } else if(!form.description) {
      toast.warning("Description is empty!")
      return false
    }
    
    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/master/site_status/helper/form.js